@use '@swisspost/design-system-styles/variables/color';
@use '@swisspost/design-system-styles/components/button';
@use '../../utils/utils.scss';
@use '../../utils/mixins.scss';

@use './widget-styles.scss';

:host {
  display: block;
}

.widget-wrapper {
  position: relative;
}

.widget-wrapper,
#post-klp-login-widget,
.klp-widget-anonymous,
.klp-widget-anonymous__wrapper,
.klp-widget-anonymous__wrapper a {
  height: 100%;
}

.klp-widget-anonymous__wrapper a {
  display: flex;
  align-items: center;
  color: color.$gray-80;
  text-decoration: none;
  padding: 0 1rem;
  transition: color 200ms;

  &:hover,
  &:focus {
    color: black;
  }

  @include mixins.min(lg) {
    padding: 0 1.125rem;
  }

  span {
    margin-right: 0.5rem;
  }

  svg {
    width: 1.5rem;
    height: 1.5rem;
  }
}

.klp-widget-anonymous__text {
  @extend %visually-hidden;

  @include mixins.between(rg, lg) {
    @include mixins.reset-visually-hidden();
  }

  @include mixins.min(xl) {
    @include mixins.reset-visually-hidden();
  }
}

#post-klp-login-widget .nameAndInfoWrapper {
  position: relative;
  display: flex;

  align-items: flex-start;
  width: 224px;
  height: 78px;
  padding: 16px 0px;
  line-height: 46px;
  flex-direction: column;
  justify-content: center;
}

.modal-content {
  position: relative;
}

.modal-text-container {
  padding-top: 3rem;
}

#post-klp-login-widget .modal-button-container {
  height: auto;
  padding: 2rem;

  & > .item-centered {
    justify-content: center;
  }
}
